module.exports = "<div class=component-has-finished> <span class=finished-con> <i class=\"icon-calendar icon-calendar-file\"></i> </span> <div class=finished-content style=display:inline-block title={{flow_name}}> <span>{{flow_name}}</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/calendar/left-content/leftContent.finished/leftContent.finished.html
// module id = 4896
// module chunks = 50